import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MenuItem, Select, Typography, Box, Container, FormControl, InputLabel, Button, TextField, Alert } from '@mui/material';
import FinancialCard from './FinancialCard';

const FinancialCardAll = ({ user }) => {
const [users, setUsers] = useState([]);
const [selectedUser, setSelectedUser] = useState(null);
const [fixLoading, setFixLoading] = useState(false);
const [fixMessage, setFixMessage] = useState(null);
const [pocetnaGodina, setPocetnaGodina] = useState(new Date().getFullYear());
const getStartDate = () => {
        const today = new Date();
        const thisYear = today.getFullYear();
        const firstDayOfYear = new Date(thisYear, 0, 1);
        const year = firstDayOfYear.getFullYear();
        const month = (firstDayOfYear.getMonth() + 1).toString().padStart(2, '0'); // meseci su 0-indexed, pa dodajemo 1
        const day = firstDayOfYear.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const getEndDate = () => {
        const today = new Date();
        const thisYear = today.getFullYear();
        const firstDayOfYear = new Date(thisYear, 0, 1);
        const year = firstDayOfYear.getFullYear();
        return `${year}-12-31`;
    };
    const [fromDateReport, setFromDateReport] = useState(getStartDate());
    const [toDateReport, setToDateReport] = useState(getEndDate());

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get('/api/users/getAllUsersFromKlub/1');
                setUsers(response.data);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };

        fetchUsers();
    }, []);

    const handleUserChange = (event) => {
        const userId = event.target.value;
        const user = users.find(u => u.id === userId);
        setSelectedUser(user);
    };

    const handlePrintAll = async () => {
        //if (!selectedUser) {
        //    return;
        //}

        try {
            const response = await axios.post('/api/Report/createAll', {
                UserId: 0,
                FromDate: fromDateReport, // Primer datuma, promenite po potrebi
                ToDate: toDateReport // Primer datuma, promenite po potrebi
            }, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.pdf');
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };
    const handlePrint = async () => {
        if (!selectedUser) {
            alert('Izaberite korisnika!');
            return;
        }

        try {
            const response = await axios.post('/api/Report/create', {
                UserId: selectedUser.id,
                FromDate: fromDateReport, // Primer datuma, promenite po potrebi
                ToDate: toDateReport // Primer datuma, promenite po potrebi
            }, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.pdf');
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    const handlePrintDetailed = async () => {
        if (!selectedUser) {
            alert('Izaberite korisnika!');
            return;
        }

        try {
            const response = await axios.post('/api/Report/createDetailed', {
                UserId: selectedUser.id,
                FromDate: fromDateReport,
                ToDate: toDateReport
            }, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `detaljni_izvestaj_${selectedUser.username || selectedUser.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating detailed PDF:', error);
            alert('Greška prilikom generisanja detaljnog izveštaja.');
        }
    };

    const handleFixSelected = async () => {
        if (!selectedUser) {
            alert('Izaberite korisnika!');
            return;
        }

        if (!window.confirm(`Da li ste sigurni da želite da sredite finansijsku karticu za ${selectedUser.fullName}?`)) {
            return;
        }

        setFixLoading(true);
        setFixMessage(null);

        try {
            const response = await axios.post(`/api/FinancialCardFix/fix/${selectedUser.id}`);
            setFixMessage({ type: 'success', text: response.data.message || 'Uspešno sredjeno!' });
        } catch (error) {
            console.error('Error fixing financial card:', error);
            setFixMessage({ type: 'error', text: error.response?.data?.message || 'Greška prilikom sredjivanja.' });
        } finally {
            setFixLoading(false);
        }
    };

    const handleFixAll = async () => {
        if (!window.confirm('Da li ste sigurni da želite da sredite finansijsku karticu za SVE članove? Ovo može potrajati.')) {
            return;
        }

        setFixLoading(true);
        setFixMessage(null);

        try {
            const response = await axios.post('/api/FinancialCardFix/fix-all');
            setFixMessage({
                type: 'success',
                text: `${response.data.message || 'Zavrseno!'} Uspešno: ${response.data.uspesnoObradjenih}, Greške: ${response.data.gresaka}`
            });
        } catch (error) {
            console.error('Error fixing all financial cards:', error);
            setFixMessage({ type: 'error', text: error.response?.data?.message || 'Greška prilikom sredjivanja.' });
        } finally {
            setFixLoading(false);
        }
    };

    const handleMasterFix = async () => {
        if (!window.confirm(`Da li ste sigurni da želite da pokrenete MASTER FIX od ${pocetnaGodina}. godine do danas?\n\nOvo će:\n- Resetovati početna stanja za ${pocetnaGodina}. na 0\n- Srediti sve kartice za svaku godinu redom\n- Rekreirati početna stanja za svaku sledeću godinu\n\nOvo može potrajati!`)) {
            return;
        }

        setFixLoading(true);
        setFixMessage(null);

        try {
            const response = await axios.post(`/api/FinancialCardFix/master-fix?pocetnaGodina=${pocetnaGodina}`);
            const data = response.data;
            const koraciText = data.koraci ? data.koraci.join('\n') : '';
            setFixMessage({
                type: 'success',
                text: `${data.message || 'Zavrseno!'}\nGrešaka: ${data.brojGresaka || 0}${koraciText ? '\n\nKoraci:\n' + koraciText : ''}`
            });
        } catch (error) {
            console.error('Error running master fix:', error);
            setFixMessage({ type: 'error', text: error.response?.data?.message || 'Greška prilikom master fix-a.' });
        } finally {
            setFixLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 8, mb: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Alert severity="warning" sx={{ width: '100%', mb: 2, fontSize: '16px', fontWeight: 'bold' }}>
                    Dragi korisniče, trenutno radimo na optimizaciji baze i trenutno finansisko stanje nije tačno. Obavestićevo te čim stanje bude pravo. Hvala na razumevanju!
                </Alert>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <TextField
                        label="Od datuma"
                        type="date"
                        value={fromDateReport}
                        onChange={(e) => setFromDateReport(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                            style: { color: 'black' }, // Dodato za crna slova
                        }}
                        sx={{ marginRight: 2 }}
                    />
                    <TextField
                        label="Do datuma"
                        type="date"
                        value={toDateReport}
                        onChange={(e) => setToDateReport(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                            style: { color: 'black' }, // Dodato za crna slova
                        }}
                    />
                </Box>

                <Button variant="contained" color="primary" onClick={handlePrintAll} sx={{ mt: 3 }}>
                    Štampa svi korisnici
                </Button>
                <Button variant="contained" color="primary" onClick={handlePrint} sx={{ mt: 3 }}>
                    Štampa izabran korisnik
                </Button>
                <Button variant="contained" color="info" onClick={handlePrintDetailed} sx={{ mt: 3 }}>
                    Detaljni izveštaj izabran korisnik
                </Button>

                {/* Dugmici za sredjivanje finansijske kartice */}
                <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleFixAll}
                        disabled={fixLoading}
                        sx={{ minWidth: 250 }}
                    >
                        {fixLoading ? 'Sredjivanje u toku...' : 'Sredi karticu - SVI članovi'}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleFixSelected}
                        disabled={fixLoading || !selectedUser}
                        sx={{ minWidth: 250 }}
                    >
                        {fixLoading ? 'Sredjivanje u toku...' : 'Sredi karticu - izabran član'}
                    </Button>
                </Box>

                {/* Master Fix dugme */}
                <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
                    <TextField
                        label="Početna godina"
                        type="number"
                        value={pocetnaGodina}
                        onChange={(e) => setPocetnaGodina(parseInt(e.target.value) || new Date().getFullYear())}
                        InputLabelProps={{
                            shrink: true,
                            style: { color: 'black' },
                        }}
                        sx={{ width: 150 }}
                    />
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleMasterFix}
                        disabled={fixLoading}
                        sx={{ minWidth: 250 }}
                    >
                        {fixLoading ? 'Master fix u toku...' : 'MASTER FIX (sve godine)'}
                    </Button>
                </Box>

                {fixMessage && (
                    <Typography
                        variant="body1"
                        component="pre"
                        sx={{
                            mt: 2,
                            p: 2,
                            borderRadius: 1,
                            backgroundColor: fixMessage.type === 'success' ? '#e8f5e9' : '#ffebee',
                            color: fixMessage.type === 'success' ? '#2e7d32' : '#c62828',
                            width: '100%',
                            textAlign: 'center',
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'inherit',
                            fontSize: 'inherit'
                        }}
                    >
                        {fixMessage.text}
                    </Typography>
                )}
                <Typography component="h1" variant="h4" color="primary" gutterBottom>
                    Pregled Finansijskih Kartica
                </Typography>
                <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                    <InputLabel id="user-select-label" sx={{ color: '#000000' }}>Izaberite korisnika</InputLabel>
                    <Select
                        labelId="user-select-label"
                        value={selectedUser ? selectedUser.id : ''}
                        onChange={handleUserChange}
                        label="Izaberite korisnika"
                        sx={{ color: '#000000' }}
                    >
                        <MenuItem value="" disabled>
                            Izaberite korisnika
                        </MenuItem>
                        {users.map(user => (
                            <MenuItem key={user.id} value={user.id}>
                                {user.fullName}({user.username})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {selectedUser && (
                    <>
                        <FinancialCard key={selectedUser.id} user={selectedUser} />
                    </>
                )}
            </Box>
        </Container>
    );
};

export default FinancialCardAll;